import React from 'react';
import Modal from "react-bootstrap/Modal";
import { CulqiProvider, Culqi } from 'react-culqi';
import API from '../../configAPI';
import APP_CONFIG from '../../config';
import BarLoader from 'react-spinners/BarLoader';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

class Pasarela_b extends React.Component{
    constructor(props){
        super(props);
        
        this.state = {
           totalproduc: JSON.parse(localStorage.getItem('total_car')) ? JSON.parse(localStorage.getItem('total_car')) : [] ,
           totalpago: JSON.parse(localStorage.getItem('total_pago')) ? JSON.parse(localStorage.getItem('total_pago')) : [] ,
           listaCarrito: JSON.parse(localStorage.getItem('Carrito')) ? JSON.parse(localStorage.getItem('Carrito')) : [] ,
           distrito_id:localStorage.getItem('distrito_id') ? localStorage.getItem('distrito_id') : [] ,
           id:cookies.get("id")?cookies.get("id"):1,
           show:false,
           constancia:1,
           adress:"",
           phone:cookies.get("phone_number") ? cookies.get("address") : "",
           name:cookies.get("name") ? cookies.get("name") +" "+ cookies.get("last_name"): "",
           dni:cookies.get("doc_number") ? cookies.get("doc_number") : "",
           ruc: "",
           city:cookies.get("distrito") ? cookies.get("distrito") : "",
           amount:this.props.amount, 
           envio:this.props.envio, 
           carrito:this.props.carrito,
           quantity:"1",
           fulled:false,
           changed:false,
           changed_amount:false,
           isButtonDisabled: false,
           isPaso1:false,
           isPaso2:false,
           isPaso3:false,
           isError:true,
           loading:false,
            
        }
        this.CerrarModal = this.CerrarModal.bind(this)
        this.openModal = this.openModal.bind(this)
        this.cont_paso1 = this.cont_paso1.bind(this)
        this.cont_paso2 = this.cont_paso2.bind(this)
        
    }
    

    openModal(){
       
        var a=JSON.parse(localStorage.getItem('Carrito'));
        var b=JSON.parse(localStorage.getItem('total_pago'));
        var c=JSON.parse(localStorage.getItem('total_envio'));
        var d=JSON.parse(localStorage.getItem('distrito_id'));
        this.setState({listaCarrito:a,amount:b,envio:c,distrito_id:d})

        var total=0;
        var precio=0;
        for(let numero in a){
            if(a[numero].descuento>0){
                precio=a[numero].fair_precio;
            }else{
                precio=a[numero].precio;
            }
            total = total + (a[numero].cantidad * precio);
        }

        this.setState({
        show: true, 
        adress:"",
        phone:cookies.get("phone_number") ? cookies.get("phone_number") : "",
        name:cookies.get("name") ? cookies.get("name") +" "+ cookies.get("last_name"): "",
        dni:cookies.get("doc_number") ? cookies.get("doc_number") : "",
        ruc: "",
        city:cookies.get("distrito") ? cookies.get("distrito"):"" ,
        quantity:"1",
        
        fulled:false,
        isPaso1:true,
        isPaso2:false,
        amount:total,
        isPaso3:false})
        
      }
    CerrarModal(){
        
       

        this.setState({show: false})

        
    }
    cont_paso1(){
        this.setState({isPaso1:true,isPaso2:false,isPaso3:false})
    }
    cont_paso2(){
        this.setState({isPaso1:false,isPaso2:true,isPaso3:false})
    }
    handlesubmit =(e)=>{
        e.preventDefault();
        this.setState({fulled: true}) 
      }
    
      handleChange = (e) =>{
           
        this.setState({
            [e.target.name] : e.target.value
        })
  
        if(e.target.value.trim()!== "" || e.target.value.trim()!== "0"){
          
          this.setState({fulled:true,changed: true })
        }
        else{
          this.setState({fulled:false,changed: false })
        }
        
      }
    onBlur(e) {
        var newVal = this.myInput.value; // uses the ref
        
        this.setState({val: newVal});
      }
  
 
    envio_mail(){
        
        API.PRODUCTS.post('confirmation_mail',{
           
        }).then(resp =>{
            
            
            if(resp.data.type === "error"){
                console.log("error")
                
            }
            else if(resp.data.type === "ok"){
                console.log("ok")
            }
        })
        .catch(err =>{
            console.log(err)
        });
    }

    vaciarcard(){
        
        for(let numero in this.state.listaCarrito){
            localStorage.removeItem("total"+this.state.listaCarrito[numero].id);
        }

        

        localStorage.removeItem("Carrito");
        localStorage.removeItem("name_distrito");
        localStorage.removeItem("distrito_id");
        localStorage.setItem("total_pago",-2);
        localStorage.setItem("total_envio",-2);
        localStorage.setItem("total_prec",0);
        localStorage.setItem("total_car",0);
        document.querySelector("#total_product").innerHTML = 0;
        
        localStorage.setItem("enviado",1);

        window.location.href = window.location.href;

    }

    alerta(token_response){
        this.setState({loading:true,isPaso2:false})
        API.PRODUCTS.post('culqui-pay',{
            id:this.state.id,
            carrito:this.state.carrito,
            currency_code: "PEN",
            amount: this.state.amount,
            token: token_response.id,
            name: this.state.name,
            adress: this.state.adress,
            city: this.state.city,
            phone: this.state.phone,
            dni: this.state.dni,
            ruc: this.state.ruc,
            distrito_id: this.state.distrito_id,
            constancia:this.state.constancia,
            email: token_response.email,
            
           
           
        })
        .then(resp =>{
            this.setState({isPaso1:false,isPaso2:false,isPaso3:true})
            
            if(resp.data.type === "error"){
                this.setState({isError:true,loading:false,message:resp.data.message})
                
            }
            else if(resp.data.type === "ok"){
                this.setState({isError:false,loading:false,message:resp.data.message})
                this.vaciarcard();
                 

            }
        })
        .catch(err =>{
            console.log(err)
            this.setState({isError:true,loading:false,message:'Ocurrio un error! recargue la página!'})
        });
      }
    error(){
        this.setState({isPaso1:false,isPaso2:false,isPaso3:true})
        this.setState({isError:true,loading:false,message:'Ocurrio un error! recargue la página!'})
    }
    render(){
        return (
            <section className="col-12">
                
                {JSON.parse(localStorage.getItem('total_pago'))==null?
                ""
                :
               JSON.parse(localStorage.getItem('total_pago'))>=0?
               <button onClick={this.openModal} className="btn btn-info btn-block" type="button">Comprar</button>
               :
               ""
                }
                
            
              <Modal show={this.state.show} onHide={this.CerrarModal} 
              //size='lg' 
              backdrop="static" keyboard={false} >
               {this.state.isPaso1 === true ? 
                <Modal.Header className="bg-secondary">
						<Modal.Title className="text-white">Datos de compra</Modal.Title>    
				</Modal.Header>
                :''}
                {this.state.isPaso2 === true ? 
                <Modal.Header className="bg-secondary">
						<Modal.Title className="text-white">Confirmar</Modal.Title>    
				</Modal.Header>
                :''}
                {this.state.isPaso3 === true && this.state.isError === true ? 
                <Modal.Header className="bg-danger">
						<Modal.Title className="text-white">Error</Modal.Title>    
				</Modal.Header>
                :''}
                {this.state.isPaso3 === true && this.state.isError === false ? 
                <Modal.Header className="bg-success">
						<Modal.Title className="text-white">Compra realizada</Modal.Title>    
				</Modal.Header>
                :''}
                <form onSubmit={this.handlesubmit}>
                <Modal.Body>
                    {this.state.isPaso1 === true ? 
                    
                    <div className="col-lg-12">
                       
                                    <div className="col-md-6 col-xs-12 mx-auto">                    
                                    <div className="form-check form-check-inline">
                                    <input className="form-check-input" type="radio" id="constancia" value="1" name="constancia" onClick={this.constancia.bind(this,1)} defaultChecked="true"></input>
                                    <label className="form-check-label" >Boleta</label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                    <input className="form-check-input" type="radio" id="constancia" value="2" name="constancia" onClick={this.constancia.bind(this,2)}></input>
                                    <label className="form-check-label" >Factura</label>
                                    </div>
                                </div>
                                <br/>
                                <div className="row form-group">
                                <div className="col-md-12">
                            {this.state.constancia==1
                            ?    
                            <input onChange={this.handleChange} className="form-control" name="dni" placeholder="DNI" defaultValue={this.state.dni} type="number" maxLength="2"/>
                            :
                            <input onChange={this.handleChange} className="form-control" name="ruc" placeholder="RUC" defaultValue={this.state.ruc} type="number" maxLength="2"/>
                            }
                                
                                </div>
                                </div>
                                <div className="row form-group">
                                <div className="col-md-12">
                                    <input onChange={this.handleChange} className="form-control" name="name" placeholder="Nombres y apellidos" defaultValue={this.state.name} required/>
                                </div>
                                </div>
                                <div className="row form-group">
                                <div className="col-md-6">
                                    <input onChange={this.handleChange} className="form-control" name="city" placeholder="Ciudad" defaultValue={this.state.city} required/>
                                </div>
                                <div className="col-md-6">
                                    <input onChange={this.handleChange} className="form-control" name="phone" placeholder="Teléfono" defaultValue={this.state.phone} type="number" required/>
                                </div>
                                </div>
                                <div className="row form-group">
                                <div className="col-md-12">
                                    <textarea onChange={this.handleChange} name="adress" className="form-control" rows="3" placeholder="Dirección" defaultValue={this.state.adress}></textarea>
                                </div>
                                </div>

                                <div className="form-group form-check">
                                <input type="checkbox" className="form-check-input" id="check" name="terminos" required defaultChecked></input>
                                <label className="form-check-label text-muted" style={{fontSize: '0.85rem'}}>Acepto los <a type="button" className="btn btn-primary calcular btn-terminos" data-toggle="modal" data-target="#exampleModal">Términos y Condiciones</a>.</label>              
                                </div> 

                                <div className="form-group form-check">
                                <input type="checkbox" className="form-check-input" id="check" defaultChecked required/>
                                <label className="form-check-label text-muted" style={{fontSize: '0.85rem'}}> Al marcar ésta casilla acepto la <a type="button" className="btn btn-primary calcular btn-terminos" data-toggle="modal" data-target="#exampleModal1"> Política de protección de datos personales</a> . </label>              
                                </div>
                                
                                <div className="form-group form-check">
                                <input type="checkbox" className="form-check-input" id="check" defaultChecked required/>
                                <label className="form-check-label text-muted" style={{fontSize: '0.85rem'}}>Autorizo el tratamiento de mis datos personales para recibir ofertas y comunicaciones comerciales por parte de esta empresa.</label>              
                                </div>

                            <div className="col-md-8 mx-auto">
                            <div className="row form-group">
                                    <h6 className="control-label col-md-6">Subtotal</h6>
                                    <div className=' col-md-6'>
                                    S/ {(this.state.amount ).toLocaleString(navigator.language, { minimumFractionDigits: 2 })}
                                    
                                    </div>
                                    <hr/>
                                </div>
                                <div className="row form-group">
                                    <h6 className="control-label col-md-6">Gastos de envío</h6>
                                    <div className=' col-md-6'>
                                    S/ {(this.state.envio).toLocaleString(navigator.language, { minimumFractionDigits: 2 })}
                                    
                                    </div>
                                    <hr/>
                                </div>
                                <div className="row form-group">
                                    <h6 className="control-label col-md-6" style={{fontWeight:"700"}}>Total</h6>
                                    <div className=' col-md-6' style={{fontWeight:"700"}}>
                                    S/ {(this.state.amount + this.state.envio).toLocaleString(navigator.language, { minimumFractionDigits: 2 }) }
                                    </div>
                                </div>
                            </div>            
                        </div>
                       
                    :'' }
                    {this.state.isPaso2 === true ?
                    <div className="col-lg-12"> 
                        <div className="row form-group">
                            <h5 className='control-label'>
                                Detalles de compra
                            </h5>
                        </div>
                        <div className="row form-group mb-1">
                            <div className="col-lg-2"></div>
                            <label className='col mb-1'>
                            Total de productos: {this.state.totalproduc}
                            </label>
                        </div>
                       
                        <div className="row form-group mb-1">
                            <div className="col-lg-2"></div>
                            <label className='col'>
                                Total: S/ {(this.state.amount+this.state.envio).toLocaleString(navigator.language, { minimumFractionDigits: 2 })}
                            </label>
                        </div>
                    </div>
                    :'' }
                    {this.state.isPaso3 === true ? 
                        <div className="col-lg-12">
                           <div className="row form-group">
                                <h5 className="col text-center control-label">{this.state.message}</h5>
                          </div> 
                        </div> 
                    : ''}
                    {this.state.loading === true ? 
                     <div className="col-lg-12 text-center">
                         <div className="row form-group">
                             <h5 className="col text-center control-label">Espere un momento...</h5>
                         </div>
                        <div className="row form-group">
                            <div className="col-lg-2"></div>
                            <div className="col text-center">
                            <BarLoader
                                width={'100%'}
                                height={6}
                                color={APP_CONFIG.spinner_color}
                                loading={true} />
                            </div>
                            <div className="col-lg-2"></div> 
                        </div>
                    
                    </div>
                    :'' }
                    
                </Modal.Body>
            {this.state.loading === false ?
                <Modal.Footer>
                {this.state.isPaso1 === true ?
                    <div className="row ">
                        {(this.state.fulled === true 
                        && this.state.amount !== "0"
                        && this.state.adress.trim() !== ""
                        && this.state.phone.trim() !== ""
                        && this.state.name.trim() !== ""
                        && this.state.city.trim() !== ""
                        && this.state.amount !== ""
                        && this.state.amount !== "NaN"
                        && parseInt(this.state.quantity) > 0) ?
                        <button className="btn btn-info mr-1" type="button" disabled={this.isButtonDisabled} onClick={this.cont_paso2}>Continuar</button> :
                        <button className="btn btn-info mr-1" type="button" disabled={true} onClick={this.cont_paso2}>Continuar</button>
                        }
                        <button className="btn btn-danger" type="button" onClick={this.CerrarModal}>Cerrar</button>
                    </div>
                :''}
                {this.state.isPaso2 === true ?
                    <div>
                        <button className="btn btn-info mr-1" type="button" onClick={this.cont_paso1}>Volver</button>
                            <CulqiProvider
                                key={this.state.amount}
                                //Publica pruebas
                                publicKey="pk_test_sXUCiBUCfkPNteTd"
                                //Publica produccion
                                // publicKey="pk_live_OhE2jDzFFYhPEkjy"
                                amount = {this.state.amount*100 + this.state.envio*100}
                                title = {"Arquiproductos"}
                                description = {""}
                                onToken={
                                    token => {
                                        this.alerta(token)
                                    }
                                }
                            onError={error => {
                                this.error()
                            }}
                            >
                            <Culqi>
                            {({ openCulqi, setAmount, amount }) => {
                            return <button onClick={openCulqi} className="btn btn-info mr-1"
                            type="button" disabled={this.state.isButtonDisabled}
                            >Continuar</button>;
                            }}
                            </Culqi>
                        </CulqiProvider>
                        <button className="btn btn-danger" type="button" onClick={this.CerrarModal}>Cerrar</button>
                    </div>
                :''}
                {this.state.isPaso3 === true && this.state.isError === true ?
                <div> 
                 <button className="btn btn-info mr-1" type="button" onClick={this.cont_paso1}>Volver a intentar</button>
                 <button className="btn btn-danger mr-1" type="button" onClick={this.CerrarModal}>Cerrar</button>
                </div>
                 : this.state.isPaso3 === true && this.state.isError === false ? 
                 <button className="btn btn-success mr-1" type="button" onClick={this.CerrarModal}>Cerrar</button> : ''
                }
                </Modal.Footer>
            : ''}
                </form>
              </Modal>
            </section>
        )}
        constancia= (id) =>{
            this.setState({constancia:id});
        }
    
}
export default Pasarela_b;